import $ from 'jquery';
import 'jquery-ui';
import 'jquery-drawer';

export default async () => {
  window.$ = $;
  window.jQuery = $;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).IScroll = require('iscroll');

  await Promise.all([
    import('@/assets/js/jquery.rwdImageMaps.js'),
    // import('@/assets/js/auto-address.js'),
    import('@/assets/js/slick/slick.js'),
  ]);
};

